import { render, staticRenderFns } from "./ModalDeleteAccount.vue?vue&type=template&id=462280fa&scoped=true&"
import script from "./ModalDeleteAccount.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteAccount.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteAccount.vue?vue&type=style&index=0&id=462280fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462280fa",
  null
  
)

component.options.__file = "ModalDeleteAccount.vue"
export default component.exports